// extracted by mini-css-extract-plugin
export default {"mainCard":"MainContainer_mainCard__3OH0N","carouselCard":"MainContainer_carouselCard__A4DA+"};